export default __webpack_public_path__ + "static/skillsMotionMobile-865cd0012aff3597e4c676c59ca0cbb5.mp4";